/* globals featureGates */

const featureGates = {
  enableSaveAndContinue: true
};

export default {
  ...featureGates,
};
